/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './portal-web-push.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import { GRPC_PORTAL_WEB_PUSH_GRPC_SERVICE_CLIENT_SETTINGS } from './portal-web-push.pbconf';
/**
 * Service client implementation for portal_web_push.PortalWebPushGrpcService
 */
@Injectable({ providedIn: 'any' })
export class PortalWebPushGrpcServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /portal_web_push.PortalWebPushGrpcService/GetConfig
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetConfigResponse>>
     */
    getConfig: (
      requestData: thisProto.GetConfigRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetConfigResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/portal_web_push.PortalWebPushGrpcService/GetConfig',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetConfigRequest,
        responseClass: thisProto.GetConfigResponse
      });
    },
    /**
     * Unary call: /portal_web_push.PortalWebPushGrpcService/RegisterSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.RegisterSubscriptionResponse>>
     */
    registerSubscription: (
      requestData: thisProto.RegisterSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.RegisterSubscriptionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/portal_web_push.PortalWebPushGrpcService/RegisterSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.RegisterSubscriptionRequest,
        responseClass: thisProto.RegisterSubscriptionResponse
      });
    },
    /**
     * Unary call: /portal_web_push.PortalWebPushGrpcService/RemoveSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.RemoveSubscriptionResponse>>
     */
    removeSubscription: (
      requestData: thisProto.RemoveSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.RemoveSubscriptionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/portal_web_push.PortalWebPushGrpcService/RemoveSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.RemoveSubscriptionRequest,
        responseClass: thisProto.RemoveSubscriptionResponse
      });
    },
    /**
     * Unary call: /portal_web_push.PortalWebPushGrpcService/GetPreferences
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetPreferencesResponse>>
     */
    getPreferences: (
      requestData: thisProto.GetPreferencesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetPreferencesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/portal_web_push.PortalWebPushGrpcService/GetPreferences',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPreferencesRequest,
        responseClass: thisProto.GetPreferencesResponse
      });
    },
    /**
     * Unary call: /portal_web_push.PortalWebPushGrpcService/SavePreferences
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SavePreferencesResponse>>
     */
    savePreferences: (
      requestData: thisProto.SavePreferencesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SavePreferencesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/portal_web_push.PortalWebPushGrpcService/SavePreferences',
        requestData,
        requestMetadata,
        requestClass: thisProto.SavePreferencesRequest,
        responseClass: thisProto.SavePreferencesResponse
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_PORTAL_WEB_PUSH_GRPC_SERVICE_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'portal_web_push.PortalWebPushGrpcService',
      settings
    );
  }

  /**
   * Unary call @/portal_web_push.PortalWebPushGrpcService/GetConfig
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetConfigResponse>
   */
  getConfig(
    requestData: thisProto.GetConfigRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetConfigResponse> {
    return this.$raw
      .getConfig(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/portal_web_push.PortalWebPushGrpcService/RegisterSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.RegisterSubscriptionResponse>
   */
  registerSubscription(
    requestData: thisProto.RegisterSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.RegisterSubscriptionResponse> {
    return this.$raw
      .registerSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/portal_web_push.PortalWebPushGrpcService/RemoveSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.RemoveSubscriptionResponse>
   */
  removeSubscription(
    requestData: thisProto.RemoveSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.RemoveSubscriptionResponse> {
    return this.$raw
      .removeSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/portal_web_push.PortalWebPushGrpcService/GetPreferences
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetPreferencesResponse>
   */
  getPreferences(
    requestData: thisProto.GetPreferencesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetPreferencesResponse> {
    return this.$raw
      .getPreferences(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/portal_web_push.PortalWebPushGrpcService/SavePreferences
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SavePreferencesResponse>
   */
  savePreferences(
    requestData: thisProto.SavePreferencesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SavePreferencesResponse> {
    return this.$raw
      .savePreferences(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
